import { ContentHeading } from 'components/Typography';
import RefundBreakdown from 'components/RefundBreakdown';
import BottomTotal from 'components/BottomTotal';
import PaymentsCard from 'components/PaymentsCard';
import { useCancellationQuote } from '../CancellationQuoteProvider';
import useDetailsBooking from 'hooks/useDetailsBooking';
import { getPendingScheduledPayment } from 'lib/bookingInfo';
import { Text } from '@qga/roo-ui/components';
import { FormattedMoney } from 'components/Formatters';

const RefundSummary = () => {
  const { cancellation } = useCancellationQuote();
  const { booking } = useDetailsBooking();
  const pendingPayment = getPendingScheduledPayment(booking);

  return (
    <>
      <ContentHeading>Refund summary</ContentHeading>

      {pendingPayment && (
        <Text as="div" mx={4} mb={[5, 8]}>
          <strong>Please note: You will not be charged</strong> the remaining payment of <FormattedMoney {...pendingPayment.total} /> for
          this booking
        </Text>
      )}

      <PaymentsCard mb={8}>
        <RefundBreakdown breakdown={cancellation?.refund?.breakdown!} penalty={[]} showHeading={false} />
        <BottomTotal title="Total refund" totals={cancellation?.refund?.totals!} />
      </PaymentsCard>
    </>
  );
};

export default RefundSummary;
